import { render, staticRenderFns } from "./BranchMediaSelector.vue?vue&type=template&id=2afbd655&scoped=true"
import script from "./BranchMediaSelector.vue?vue&type=script&lang=js"
export * from "./BranchMediaSelector.vue?vue&type=script&lang=js"
import style0 from "./BranchMediaSelector.vue?vue&type=style&index=0&id=2afbd655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afbd655",
  null
  
)

export default component.exports